export const AddRelationElement =  ()=>{
    return (
        <div className="container">
            移動やモンスターリレーションでカードを紐づけます
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_add_relation.png`}></img></p>
            上記例ではkokaという<a href="/tcgcreatoreternalbetaver2/card_variable">カード変数</a>にequpという名前でモンスター効果で紐づけを受けるようにしています
        </div>
    )
}
